import * as React from 'react';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { CommandButton, IButtonStyles } from '@fluentui/react/lib/Button';
import { DefaultPalette } from '@uifabric/styling/lib/index';
import { getPalette } from 'owa-theme';

export interface ComposeActionButtonProps extends React.HTMLProps<HTMLDivElement> {
    id: string;
    caption: string;
    ariaLabel?: string;
    onClick: () => void;
    colors?: ColorScheme;
}

export default function ComposeActionButton(props: ComposeActionButtonProps) {
    let { colors, caption } = props;
    let customStyle = calculateButtonStyle(colors);
    return (
        <CommandButton
            styles={customStyle}
            onClick={props.onClick}
            className={props.className}
            disabled={props.disabled}>
            {caption}
        </CommandButton>
    );
}

function calculateButtonStyle(colors: ColorScheme): IButtonStyles {
    let themeSymbols = getPalette();
    let rootColor = colors ? colors.calPrimary : themeSymbols.themePrimary;
    let hoverColor = colors ? colors.calDarkAlt : themeSymbols.themeDarkAlt;
    let pressedColor = colors ? colors.calDark : themeSymbols.themeDark;
    let focusBorderColor = colors ? colors.calDarkAlt : themeSymbols.themeDarker;
    let textColor = colors ? colors.accessibleText.calPrimaryBackground : DefaultPalette.white;
    let customStyle: IButtonStyles = {
        root: {
            minWidth: 80,
            height: 32,
            backgroundColor: rootColor,
            color: textColor,
            fontWeight: 600,
        },
        flexContainer: {
            justifyContent: 'center',
        },
        rootHovered: {
            backgroundColor: hoverColor,
            color: textColor,
        },
        rootPressed: {
            backgroundColor: pressedColor,
            color: textColor,
            border: 'none', // To avoid showing focused border on press
            boxShadow: 'none',
        },
        rootFocused: {
            border: 'solid 1px ' + DefaultPalette.white, // Inner border
            boxShadow: '0 0 0 1px ' + focusBorderColor, // Outer border
            color: textColor,
        },
        rootDisabled: {
            backgroundColor: DefaultPalette.neutralLight,
            color: DefaultPalette.neutralTertiary,
        },
    };
    return customStyle;
}
